'use client';

import { useTranslation } from '@/lib/i18n/i18n.client';

import Button from '@/decodo/components/atoms/Button';
import { Input } from '@/decodo/components/atoms/Input';
import RichTextFieldStrapi from '@/decodo/components/atoms/RichTextField/RichTextFieldStrapi';

import { CaptureUserDetailsProps } from '../GatedContent/types';
import useCaptureUserDetails from '../GatedContent/useCaptureUserDetails';

export const LeadPopUp = (
  props: CaptureUserDetailsProps & { onError: () => void } & {
    onSuccess: () => void;
  }
) => {
  const { texts } = useTranslation();

  const { errors, handleSubmit, values, getFieldProps, isLoading } =
    useCaptureUserDetails(props, { context: 'leadPopUp' });
  const handleFormSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    try {
      await handleSubmit(e);
      props.onSuccess();
    } catch (error) {
      props.onError();
    }
  };

  return (
    <>
      <RichTextFieldStrapi
        block={props.title}
        classNames={{
          paragraph: 'text-h2 mb-5 m:mb-6 font-serif m:flex m:justify-center',
        }}
      />

      <RichTextFieldStrapi
        block={props.description}
        classNames={{
          paragraph:
            'text-body-l font-mono text-gray-500 mb-8 m:mb-12 m:flex m:justify-center',
        }}
      />

      <form
        className='flex flex-col text-left'
        onSubmit={handleFormSubmit}
        data-test-id='gated-content-form'
      >
        <Input
          placeholder={texts.gated_content.placeholder_email}
          label={texts.gated_content.label_email}
          required
          error={errors.email || ''}
          {...getFieldProps('email')}
          classNames={{
            label: {
              root: 'text-gray-500 uppercase text-label-medium font-serif',
            },
            bottomText: { root: 'h-6' },
          }}
        />
        <Button
          classNames={{
            root: 'w-full mb-6',
          }}
          onMouseDown={(e: React.MouseEvent<HTMLButtonElement>) =>
            e.preventDefault()
          }
          type='submit'
          disabled={!values.email || !!errors.email || isLoading}
        >
          <RichTextFieldStrapi block={props.submitButtonText} />
        </Button>
      </form>
      <div className='m:flex m:!justify-center'>
        <RichTextFieldStrapi
          block={props.termsAndConditions}
          classNames={{
            paragraph: 'text-gray-500 text-body-m font-mono',
          }}
        />
      </div>
    </>
  );
};
